{
  "nl-NL": {
    "model": {
      "profile": {
        "id": "Gebruikers-ID",
        "userName": "Gebruikersnaam",
        "email": "E-mailadres",
        "emailConfirmed": "E-mailadres bevestigd",
        "phoneNumber": "Telefoonnummer",
        "phoneNumberConfirmed": "Telefoonnummer bevestigd",
        "twoFactorEnabled": "Tweefactorauthenticatie ingeschakeld.",
        "lockoutEnd": "Einde van de vergrendelperiode.",
        "lockoutEnabled": "Blokkering ingeschakeld",
        "accessFailedCount": "Aantal mislukte toegangspogingen",
        "firstName": "Voornaam",
        "lastName": "Achternaam",
        "picture": "Afbeelding voor het profiel",
        "organisationName": "Organisatie",
        "name": "Naam",
        "roles": "Rollen"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Bevestigd"
      },
      "action": {
        "resetPassword.tooltip": "Stuur instructies voor het opnieuw instellen van het wachtwoord naar de gebruiker via e-mail."
      },
      "message": {
        "resetPassword.success": "Er is een e-mail naar de gebruiker gestuurd met instructies voor het opnieuw instellen van hun wachtwoord."
      }
    }
  }
}